/* ==========================================================================
   Squizo theme — global JavaScript
   ========================================================================== */
(function () {
  'use strict';

  const routes = window.routes || {};
  const cartStrings = window.cartStrings || {};

  /* --------------------------------------------------------------------- */
  /* Helpers                                                                */
  /* --------------------------------------------------------------------- */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  async function postJSON(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    return res.json();
  }

  async function getCart() {
    const res = await fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* --------------------------------------------------------------------- */
  /* Mobile navigation                                                      */
  /* --------------------------------------------------------------------- */
  function initMobileNav() {
    const nav = $('[data-mobile-nav]');
    const overlay = $('[data-mobile-nav-overlay]');
    const open = () => { nav && nav.classList.add('is-open'); overlay && overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const close = () => { nav && nav.classList.remove('is-open'); overlay && overlay.classList.remove('is-open'); document.body.style.overflow = ''; };
    $$('[data-mobile-nav-toggle]').forEach((b) => b.addEventListener('click', open));
    $$('[data-mobile-nav-close]').forEach((b) => b.addEventListener('click', close));
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* --------------------------------------------------------------------- */
  /* Search modal                                                           */
  /* --------------------------------------------------------------------- */
  function initSearch() {
    const modal = $('[data-search-modal]');
    if (!modal) return;
    const open = () => { modal.classList.add('is-open'); const inp = modal.querySelector('input'); inp && setTimeout(() => inp.focus(), 100); };
    const close = () => modal.classList.remove('is-open');
    $$('[data-search-toggle]').forEach((b) => b.addEventListener('click', open));
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* --------------------------------------------------------------------- */
  /* Announcement rotator                                                   */
  /* --------------------------------------------------------------------- */
  function initAnnouncement() {
    const track = $('[data-announcement-track]');
    if (!track) return;
    const slides = $$('.announcement__slide', track);
    if (slides.length < 2) return;
    let index = 0;
    const go = (i) => { index = (i + slides.length) % slides.length; track.style.transform = `translateX(-${index * 100}%)`; };
    const prev = $('[data-announcement-prev]');
    const next = $('[data-announcement-next]');
    prev && prev.addEventListener('click', () => go(index - 1));
    next && next.addEventListener('click', () => go(index + 1));
    let timer = setInterval(() => go(index + 1), 5000);
    track.closest('.announcement').addEventListener('mouseenter', () => clearInterval(timer));
    track.closest('.announcement').addEventListener('mouseleave', () => { timer = setInterval(() => go(index + 1), 5000); });
  }

  /* --------------------------------------------------------------------- */
  /* Hero slideshow                                                         */
  /* --------------------------------------------------------------------- */
  function initHero() {
    $$('[data-hero]').forEach((hero) => {
      const track = $('[data-hero-track]', hero);
      const slides = $$('.hero__slide', track);
      if (slides.length < 2) return;
      let index = 0;
      const dots = $$('[data-hero-dot]', hero);
      const go = (i) => {
        index = (i + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
      };
      $('[data-hero-prev]', hero) && $('[data-hero-prev]', hero).addEventListener('click', () => { go(index - 1); reset(); });
      $('[data-hero-next]', hero) && $('[data-hero-next]', hero).addEventListener('click', () => { go(index + 1); reset(); });
      dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.heroDot, 10)); reset(); }));
      let timer;
      const start = () => { timer = setInterval(() => go(index + 1), 6000); };
      const reset = () => { clearInterval(timer); start(); };
      start();
      hero.addEventListener('mouseenter', () => clearInterval(timer));
      hero.addEventListener('mouseleave', start);
    });
  }

  /* --------------------------------------------------------------------- */
  /* Cart drawer                                                            */
  /* --------------------------------------------------------------------- */
  const cartConfig = window.cartConfig || {};
  const CD_ICON = {
    minus: '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    plus: '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    trash: '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>'
  };

  function drawerEl() { return $('[data-cart-drawer]'); }

  function openCartDrawer() {
    const d = drawerEl();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    getCart().then(renderCartDrawer).catch(() => {});
  }

  function closeCartDrawer() {
    const d = drawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function cdImg(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function cdShipHTML(total) {
    const t = cartConfig.freeShippingThreshold;
    if (!cartConfig.freeShippingEnabled || !t) return '';
    const remaining = t - total;
    const progress = Math.min(100, (total / t) * 100);
    const done = remaining <= 0;
    const msg = done
      ? '🎉 You\'ve unlocked <strong>free shipping!</strong>'
      : 'You\'re <strong>' + formatMoney(remaining) + '</strong> away from free shipping!';
    return '<div class="cd-ship ' + (done ? 'cd-ship--done' : '') + '">' +
      '<p class="cd-ship__msg">' + msg + '</p>' +
      '<div class="cd-ship__track"><span class="cd-ship__fill" style="width:' + progress + '%"></span></div></div>';
  }

  function cdItemHTML(item) {
    const variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
      ? '<div class="cd-item__variant">' + item.variant_title + '</div>' : '';
    const img = item.image ? '<img src="' + cdImg(item.image) + '" alt="" loading="lazy">' : '';
    return '<li class="cd-item" data-cd-item data-key="' + item.key + '">' +
      '<a href="' + item.url + '" class="cd-item__img">' + img + '</a>' +
      '<div class="cd-item__main">' +
        '<a href="' + item.url + '" class="cd-item__title">' + item.product_title + '</a>' +
        variant +
        '<div class="cd-item__row">' +
          '<div class="qty-selector qty-selector--sm">' +
            '<button type="button" data-cd-minus data-key="' + item.key + '" aria-label="Decrease">' + CD_ICON.minus + '</button>' +
            '<input type="number" value="' + item.quantity + '" min="0" data-cd-qty data-key="' + item.key + '" aria-label="Quantity">' +
            '<button type="button" data-cd-plus data-key="' + item.key + '" aria-label="Increase">' + CD_ICON.plus + '</button>' +
          '</div>' +
          '<button type="button" class="cd-item__remove" data-cd-remove data-key="' + item.key + '">' + CD_ICON.trash + ' Remove</button>' +
        '</div>' +
      '</div>' +
      '<div class="cd-item__price">' + formatMoney(item.final_line_price) + '</div>' +
    '</li>';
  }

  function cdEmptyHTML() {
    return '<div class="cd-empty"><div class="cd-empty__emoji">🧸</div>' +
      '<p>Your cart is empty</p>' +
      '<a href="/collections/all" class="btn">Continue shopping</a></div>';
  }

  function renderCartDrawer(cart) {
    const d = drawerEl();
    if (!d || !cart) return;
    d.classList.toggle('is-empty', cart.item_count === 0);
    $$('[data-cart-drawer-count]', d).forEach((el) => { el.textContent = cart.item_count; });
    const sub = $('[data-cart-drawer-subtotal]', d);
    if (sub) sub.textContent = formatMoney(cart.total_price);
    const content = $('[data-cart-drawer-content]', d);
    if (!content) return;
    if (cart.item_count === 0) { content.innerHTML = cdEmptyHTML(); return; }
    let html = cdShipHTML(cart.total_price) + '<ul class="cd-items">';
    cart.items.forEach((it) => { html += cdItemHTML(it); });
    content.innerHTML = html + '</ul>';
  }

  async function changeCartByKey(key, quantity) {
    try {
      const cart = await postJSON(routes.cart_change_url, { id: key, quantity: quantity });
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      if ($('#cart')) window.location.reload(); // keep the full cart page in sync
    } catch (err) { /* silently ignore */ }
  }

  function initCartDrawer() {
    const d = drawerEl();
    if (!d) return;
    $$('[data-cart-toggle]').forEach((el) => {
      el.addEventListener('click', (e) => {
        if (cartConfig.cartType === 'drawer') { e.preventDefault(); openCartDrawer(); }
      });
    });
    $$('[data-cart-drawer-close]', d).forEach((el) => el.addEventListener('click', closeCartDrawer));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCartDrawer(); });
    d.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-cd-minus]');
      const plus = e.target.closest('[data-cd-plus]');
      const remove = e.target.closest('[data-cd-remove]');
      if (minus || plus) {
        const key = (minus || plus).dataset.key;
        const input = d.querySelector('input[data-cd-qty][data-key="' + key + '"]');
        let val = parseInt(input.value, 10) || 1;
        val = minus ? Math.max(0, val - 1) : val + 1;
        changeCartByKey(key, val);
      }
      if (remove) changeCartByKey(remove.dataset.key, 0);
    });
    d.addEventListener('change', (e) => {
      const qty = e.target.closest('[data-cd-qty]');
      if (qty) changeCartByKey(qty.dataset.key, parseInt(qty.value, 10) || 0);
    });
  }

  /* --------------------------------------------------------------------- */
  /* Quantity selectors                                                     */
  /* --------------------------------------------------------------------- */
  function initQtySelectors() {
    document.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-qty-minus]');
      const plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      const wrap = (minus || plus).closest('.qty-selector');
      const input = wrap.querySelector('input');
      let val = parseInt(input.value, 10) || 1;
      if (minus) val = Math.max(1, val - 1);
      if (plus) val = val + 1;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* --------------------------------------------------------------------- */
  /* Product page — gallery + variants                                      */
  /* --------------------------------------------------------------------- */
  function initProduct() {
    const product = $('[data-product]');
    if (!product) return;

    // Gallery thumbs
    const mainImg = $('#ProductMainImage', product);
    $$('[data-product-thumb]', product).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImg) mainImg.src = thumb.dataset.full;
        $$('[data-product-thumb]', product).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    // Variant selection
    const variantSelect = $('[data-variant-id-input]', product);
    const optionInputs = $$('[data-option-selector]', product);
    const priceWrap = $('[data-product-price]', product);
    const addBtn = $('[data-add-to-cart]', product);
    const addText = $('[data-add-text]', product);

    function currentOptions() {
      const opts = [];
      const groups = {};
      optionInputs.forEach((i) => {
        if (i.checked) groups[i.name] = i.value;
      });
      Object.keys(groups).sort().forEach((k) => opts.push(groups[k]));
      return opts;
    }

    function updateVariant() {
      if (!variantSelect) return;
      const chosen = currentOptions();
      let matched = null;
      $$('option', variantSelect).forEach((opt) => {
        if (opt.textContent.trim() === chosen.join(' / ')) matched = opt;
      });
      if (!matched && optionInputs.length === 0) matched = variantSelect.querySelector('option');
      if (matched) {
        variantSelect.value = matched.value;
        const price = matched.dataset.price;
        const compare = matched.dataset.compare;
        if (priceWrap && price) {
          priceWrap.innerHTML = `<div class="price ${compare ? 'price--on-sale' : ''}"><span class="price__regular">${price}</span>${compare ? `<span class="price__compare">${compare}</span>` : ''}</div>`;
        }
        const disabled = matched.disabled;
        if (addBtn) addBtn.disabled = disabled;
        if (addText) addText.textContent = disabled ? 'Sold out' : 'Add to cart';
      }
    }

    optionInputs.forEach((i) => i.addEventListener('change', updateVariant));
    updateVariant();
  }

  /* --------------------------------------------------------------------- */
  /* Add to cart (AJAX) — product form + quick add                          */
  /* --------------------------------------------------------------------- */
  function initAddToCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('#ProductForm, [data-quick-add]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalHTML = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
      try {
        const formData = new FormData(form);
        const res = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: formData
        });
        const data = await res.json();
        if (data.status) {
          alert(data.description || cartStrings.error);
        } else {
          const cart = await getCart();
          updateCartCount(cart.item_count);
          renderCartDrawer(cart);
          if (cartConfig.cartType === 'drawer') openCartDrawer();
          if (btn) { btn.innerHTML = '✓ Added!'; }
          setTimeout(() => { if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; } }, 1400);
        }
      } catch (err) {
        alert(cartStrings.error || 'Something went wrong.');
        if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; }
      }
    });
  }

  /* --------------------------------------------------------------------- */
  /* Cart page — quantity change / remove                                   */
  /* --------------------------------------------------------------------- */
  function initCartPage() {
    const cartForm = $('#cart');
    if (!cartForm) return;

    function updateFreeShipping(totalPrice) {
      const bar = $('[data-free-shipping]');
      if (!bar) return;
      const threshold = parseInt(bar.dataset.threshold, 10);
      const fill = $('[data-shipping-fill]', bar);
      const msg = $('[data-shipping-msg]', bar);
      const remaining = threshold - totalPrice;
      const progress = Math.min(100, (totalPrice / threshold) * 100);
      if (fill) fill.style.width = progress + '%';
      if (remaining <= 0) {
        bar.classList.add('free-shipping--complete');
        if (msg) msg.innerHTML = "🎉 You've unlocked <strong>free shipping!</strong>";
      } else {
        bar.classList.remove('free-shipping--complete');
        if (msg) msg.innerHTML = `You're <strong>${formatMoney(remaining)}</strong> away from free shipping!`;
      }
    }

    async function changeLine(line, quantity) {
      const cart = await postJSON(routes.cart_change_url, { line: line, quantity: quantity });
      updateCartCount(cart.item_count);
      if (cart.item_count === 0) { window.location.reload(); return; }
      const item = cart.items.find((_, idx) => idx + 1 === line);
      const row = $(`[data-line="${line}"]`)?.closest('[data-cart-item]');
      if (quantity === 0 && row) { row.remove(); }
      const subtotal = $('[data-cart-subtotal]');
      const total = $('[data-cart-total]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (total) total.textContent = formatMoney(cart.total_price);
      if (item && row) {
        const priceEl = row.querySelector('.cart-item__price');
        if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
      }
      updateFreeShipping(cart.total_price);
    }

    cartForm.addEventListener('change', (e) => {
      const qty = e.target.closest('[data-cart-qty]');
      if (qty) {
        const line = parseInt(qty.dataset.line, 10);
        changeLine(line, parseInt(qty.value, 10) || 0);
      }
    });

    cartForm.addEventListener('click', (e) => {
      const remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        changeLine(parseInt(remove.dataset.line, 10), 0);
      }
      const minus = e.target.closest('[data-cart-minus]');
      const plus = e.target.closest('[data-cart-plus]');
      if (minus || plus) {
        const input = (minus || plus).closest('.qty-selector').querySelector('[data-cart-qty]');
        setTimeout(() => changeLine(parseInt(input.dataset.line, 10), parseInt(input.value, 10) || 0), 0);
      }
    });
  }

  /* --------------------------------------------------------------------- */
  /* Collection sort                                                        */
  /* --------------------------------------------------------------------- */
  function initSort() {
    const select = $('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* --------------------------------------------------------------------- */
  /* Scroll reveal                                                          */
  /* --------------------------------------------------------------------- */
  function initReveal() {
    const els = $$('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* --------------------------------------------------------------------- */
  /* Init                                                                   */
  /* --------------------------------------------------------------------- */
  function init() {
    initMobileNav();
    initSearch();
    initAnnouncement();
    initHero();
    initCartDrawer();
    initQtySelectors();
    initProduct();
    initAddToCart();
    initCartPage();
    initSort();
    initReveal();
    updateCartCount(document.querySelector('[data-cart-count]')?.textContent.trim() || 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
